/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionInfo
 */
export interface ProductionInfo {
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfo
     */
    forceCustomBatesStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfo
     */
    regenerateFilesFromOtherDocs?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionInfo
     */
    hiddenCaseFiles?: Array<string> | null;
}

export function ProductionInfoFromJSON(json: any): ProductionInfo {
    return ProductionInfoFromJSONTyped(json, false);
}

export function ProductionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'forceCustomBatesStart': !exists(json, 'forceCustomBatesStart') ? undefined : json['forceCustomBatesStart'],
        'regenerateFilesFromOtherDocs': !exists(json, 'regenerateFilesFromOtherDocs') ? undefined : json['regenerateFilesFromOtherDocs'],
        'hiddenCaseFiles': !exists(json, 'hiddenCaseFiles') ? undefined : json['hiddenCaseFiles'],
    };
}

export function ProductionInfoToJSON(value?: ProductionInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'forceCustomBatesStart': value.forceCustomBatesStart,
        'regenerateFilesFromOtherDocs': value.regenerateFilesFromOtherDocs,
        'hiddenCaseFiles': value.hiddenCaseFiles,
    };
}


